import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import UserActions from "../../../User/reducer";

const useFetchAdminDescriptorsList = ({
  enrollmentId,
  filters,
  PAGE_SIZE,
  skipFiltersUpdate,
  setSkipFiltersUpdate,
  userEnrollmentsFetching,
}) => {
  const dispatch = useDispatch();
  const {
    adminDescriptorsByEnrollment,
    adminDescriptorsByEnrollmentFetching,
    moreAdminDescriptorsByEnrollmentFetching,
  } = useSelector((state) => state.user);
  const [page, setPage] = useState(1);
  const hasMore = adminDescriptorsByEnrollment?.count > page * PAGE_SIZE;
  const moreLoading = moreAdminDescriptorsByEnrollmentFetching;
  const loading = adminDescriptorsByEnrollmentFetching;
  const descriptors = adminDescriptorsByEnrollment?.results || [];
  const firstFiltersEffect = useRef(true);

  const fetchDescriptorsReq = (params) => {
    dispatch(UserActions.getAdminDescriptorsByEnrollmentRequest(params));
  };

  const fetchMoreDescriptorsReq = (params) => {
    dispatch(UserActions.getMoreAdminDescriptorsByEnrollmentRequest(params));
  };

  const fetchDescriptors = () => {
    if (!enrollmentId) return;
    fetchDescriptorsReq({
      enrollment_id: enrollmentId,
      descriptor: filters?.search || null,
      status: filters?.statuses?.join(",") || null,
      page: 1,
      page_size: PAGE_SIZE,
    });
    setPage(1);
  };

  const fetchMore = () => {
    if (!enrollmentId || !hasMore || moreLoading) {
      return;
    }
    fetchMoreDescriptorsReq({
      enrollment_id: enrollmentId,
      descriptor: filters?.search || null,
      status: filters?.statuses?.join(",") || null,
      page: page + 1,
      page_size: PAGE_SIZE,
    });
    setPage((prevPage) => prevPage + 1);
  };

  useEffect(() => {
    if (enrollmentId && !userEnrollmentsFetching) {
      fetchDescriptors();
    }
  }, [enrollmentId, userEnrollmentsFetching]);

  useEffect(() => {
    if (firstFiltersEffect.current) {
      firstFiltersEffect.current = false;
      return;
    }
    let timeout;
    if (enrollmentId && !skipFiltersUpdate) {
      timeout = setTimeout(() => {
        fetchDescriptors();
      }, 300);
    }
    if (skipFiltersUpdate) {
      setSkipFiltersUpdate?.(false);
    }
    return () => clearTimeout(timeout);
  }, [filters]);

  return { descriptors, fetchMore, hasMore, loading, moreLoading };
};

export default useFetchAdminDescriptorsList;
